import React from 'react';
import { HStack } from '~/components/gluestack/hstack';
import { Text } from '~/components/gluestack/text';
import { Tooltip, TooltipContent, TooltipText } from '~/components/gluestack/tooltip';
import { CountryFlagIcon } from '~/components/ui/CountryFlagIcon';
import { useMeasurementFormatters } from '~/components/providers/MeasurementsProvider';

interface CardLocationRowProps {
  placeName?: string | null;
  placeNameFull?: string | null;
  countryCode?: string;
  distanceKm?: number | null;
}

export function CardLocationRow({ placeName, placeNameFull, countryCode, distanceKm }: CardLocationRowProps) {
  const { formatDistance } = useMeasurementFormatters();
  const formattedDistance = formatDistance(distanceKm);

  if (!placeName && !formattedDistance && !countryCode) return null;

  const tooltipLabel = placeNameFull || placeName || '';

  return (
    <Tooltip
      placement="bottom"
      trigger={(triggerProps) => (
        <HStack {...triggerProps} className="w-full items-center justify-center gap-2">
          {placeName ? (
            <Text size="xs" className="shrink" isTruncated>
              {placeName}
            </Text>
          ) : null}
          {countryCode ? (
            <CountryFlagIcon
              countryCode={countryCode}
              size={16}
              className="flex-shrink-0"
            />
          ) : null}
          <Text
            size="xs"
            className="flex-shrink-0 whitespace-nowrap">
            {formattedDistance}
          </Text>
        </HStack>
      )}>
      <TooltipContent className="bg-background-700">
        <TooltipText className="text-typography-50">{tooltipLabel}</TooltipText>
      </TooltipContent>
    </Tooltip>
  );
}
